import React from 'react';
import { styled } from '@material-ui/core';
import { GridColumnMenu } from '@mui/x-data-grid';

const CustomDataGridColumnMenu = (currentOfficeTheme, otherProps) => {
	// Styles
	const StyledGridColumnMenu = styled(GridColumnMenu)(({ theme, ownerState }) => ({
		background: currentOfficeTheme.bodyBackgroundColor,
		color: currentOfficeTheme.bodyForegroundColor,
	}));

	const { hideMenu, colDef, color, ...other } = otherProps;

	return (
		<StyledGridColumnMenu
			style={{
				'& .MuiListItemIconRoot': {
					color: currentOfficeTheme.bodyForegroundColor,
					background: currentOfficeTheme.bodyBackgroundColor,
				},
			}}
			hideMenu={hideMenu}
			colDef={colDef}
			color={color}
			{...other}
		/>
	);
};

export default CustomDataGridColumnMenu;
